import { MutableRefObject, useEffect } from 'react';

export const useHorizontalScroll = ({
  scrollRef,
  enabled = true,
}: {
  scrollRef: MutableRefObject<HTMLDivElement | null>;
  enabled?: boolean;
}) => {
  useEffect(() => {
    const slider = scrollRef.current as HTMLDivElement;

    if (!enabled) return;

    let mouseDown = false;
    let startX: number;
    let scrollLeft: number;

    const startDragging = (e: MouseEvent) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
      mouseDown = false;
    };

    const mouseDragging = (e: MouseEvent) => {
      e.preventDefault();

      if (!mouseDown) return;

      const x = e.pageX - slider.offsetLeft;

      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    };

    // Attach events
    slider?.addEventListener('mousemove', mouseDragging, false);

    slider?.addEventListener('mousedown', startDragging, false);
    slider?.addEventListener('mouseup', stopDragging, false);
    slider?.addEventListener('mouseleave', stopDragging, false);

    // Cleanup
    return () => {
      slider?.removeEventListener('mousemove', mouseDragging, false);

      slider?.removeEventListener('mousedown', startDragging, false);
      slider?.removeEventListener('mouseup', stopDragging, false);
      slider?.removeEventListener('mouseleave', stopDragging, false);
    };
  }, [scrollRef.current, enabled]);
};
